import { sgg } from 'ml-savitzky-golay-generalized';
/**
 * Calculate the third derivative using Savitzky–Golay filter.
 * @param data
 */
export function thirdDerivative(data, options = {}) {
    const { x, y } = data;
    return { data: { x, y: sgg(y, x, { ...options, derivative: 3 }) } };
}
//# sourceMappingURL=thirdDerivative.js.map